// extracted by mini-css-extract-plugin
export default {"button":"UpButton_button__4K+0c"};